var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('page-title',{attrs:{"pageTitle":this.$options.name.replace(/([a-z])([A-Z])/g, '$1 $2'),"title":_vm.title,"content":_vm.content,"img":_vm.img}}),_c('TeamCards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }